import axiosInstance from "../api/axiosInstance";
import { STATES } from "../constants/API_URLs";

export const getStates = (params: any): Promise<any> => {
  return axiosInstance.get(STATES, { params });
};
